'use client';

import { createContext, useContext, ReactNode } from 'react';
import { useEnterHomeNotificationBanner } from '@/features/notifications/hooks/use-notification-banner';
import type {
    NotificationBannerCarouselItem,
    NotificationBannerProps,
} from '@enter/business-components/components/notification-banner';

interface NotificationBannerContextValue {
    notificationBanner: NotificationBannerProps | null;
    handleBannerClose: (activeBanner?: NotificationBannerCarouselItem) => void;
}

const NotificationBannerContext = createContext<NotificationBannerContextValue>({
    notificationBanner: null,
    handleBannerClose: () => {},
});

export function NotificationBannerProvider({ children }: { children: ReactNode }) {
    const { notificationBanner, handleBannerClose } = useEnterHomeNotificationBanner();

    return (
        <NotificationBannerContext.Provider value={{ notificationBanner, handleBannerClose }}>
            {children}
        </NotificationBannerContext.Provider>
    );
}

export function useNotificationBannerContext() {
    return useContext(NotificationBannerContext);
}
